/**
 * This mixin is used to detect the types of the properties in a list
 * of objects
 */
const dateRegex = '^[0-9]{2,4}[-:.][0-9]{2,4}[-:.][0-9]{2,4}[aptmATPM0-9:]*$';
export default {
  data() {
    return {
      tableTypes: {},
    };
  },
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    forceTypes: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    types() {
      let types = {};
      if (typeof this.items === 'undefined' || !this.items[0]) {
        return this.forceTypes;
      }
      if (
        Object.keys(this.tableTypes).length > 0 &&
        ((this.items[0] &&
          Object.keys(this.items[0]).length ===
            Object.keys(this.tableTypes).length) ||
          !this.items[0])
      ) {
        return this.tableTypes;
      }
      this.filteredColumnTypes(types);
      this.tableTypes = types;
      return types;
    },
  },
  methods: {
    filteredColumnTypes(types) {
      let firstItem = { ...this.items[0], ...this.filters, ...this.forceTypes };
      for (let column in firstItem) {
        if (this.forceTypes[column] !== undefined) {
          types[column] = this.forceTypes[column];
          continue;
        }
        let value = '';
        this.getColumnTypes(value, column, types);
      }
    },
    getColumnTypes(value, column, types) {
      let itemIdx = 0;
      // find a value that's populated
      if (this.items[0] && Object.keys(this.items[0]).length > 0) {
        value = this.items[itemIdx] ? this.items[itemIdx][column] : undefined;
        value = this.getValueTypes(value, column, itemIdx);
      } else if (Object.keys(this.filters).length > 0) {
        value = this.filters[column];
      }
      this.populateTypes(value, column, types);
    },
    getValueTypes(value, column, itemIdx) {
      while (!this.isPopulatedValue(value) && itemIdx <= this.items.length) {
        itemIdx++;
        value = this.items[itemIdx] ? this.items[itemIdx][column] : undefined;
      }
      return value;
    },
    populateTypes(value, column, types) {
      // determine the type
      if (typeof value === 'boolean') {
        types[column] = 'string';
      } else if (!isNaN(value)) {
        types[column] = 'number';
      } else if (this.isDate(value)) {
        types[column] = 'date';
      } else {
        types[column] = 'string';
      }
    },
    isDate(value) {
      if (RegExp(dateRegex).test(value)) {
        value = new Date(value);
        //check if the value is an date object
        if (
          Object.prototype.toString.call(value) === '[object Date]' &&
          !(isNaN(value.getDate()) || isNaN(value.getTime()))
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    isPopulatedValue(value) {
      if (value === null) return false;
      if (value === 'null') return false;
      if (value === undefined) return false;
      if (value === 'undefined') return false;
      if (value === '') return false;
      return true;
    },
    getType(column) {
      return this.types[column];
    },
  },
};
